module.exports = __webpack_public_path__ + "img/male_resultA.89925ba2.png";